<div class="page-container">
  @if (showHeaderFooter()) {
    <app-header />
  }
  <div appAuthLogout (publicPage)="isPublicPage($event)" (staticPage)="isStaticPage($event)"></div>
  <div appLogoutAfterIdleTime [timerInHHmmss]="timerInHHmmss"></div>
  <main [class]="showHeaderFooter() ? 'p-4' : 'px-2 py-0'">
    <router-outlet />
  </main>
  @if (showHeaderFooter()) {
    <app-footer />
  }
  <app-build-number />
  <app-cookie-consent />
  <p-toast key="global-toast" [style]="{width: '22rem'}" />
</div>
